<template>
	<div class="system-page container">
		<section class="system-heading">
			<div>
				<p>SYSTEM SETTINGS</p>
				<h2>系统配置</h2>
				<span>集中维护宝塔面板与国家访问规则。</span>
			</div>
			<el-button v-if="isLanding && isAdmin" type="primary" icon="el-icon-plus" @click="addConfig">新增面板配置</el-button>
		</section>
		<el-card class="system-card" shadow="never">
			<el-tabs v-model="key" @tab-click="load">
				<el-tab-pane label="宝塔配置" name="LANDING" />
				<el-tab-pane label="国家白名单" name="COUNTRY" />
			</el-tabs>
			<agree-country v-if="isCountry" />
			<el-form v-if="!isCountry" label-width="110px">
				<el-form-item v-if="isLanding" label="说明">
					<el-input v-model="form.desc" :disabled="!isAdmin" placeholder="请输入配置说明" />
				</el-form-item>
				<template v-if="isLanding">
					<el-card v-for="(item, index) in form.config" :key="index" class="config-card" shadow="never">
						<div slot="header">
							<span><i class="el-icon-connection" /> 面板配置 {{ index + 1 }}</span>
							<el-button v-if="isAdmin" style="float: right" type="text" class="remove-button" @click="removeConfig(index)">移除</el-button>
						</div>
						<el-form-item label="Host">
							<el-input v-model.trim="item.host" :disabled="!isAdmin" placeholder="请输入宝塔面板地址，例如：http://127.0.0.1:8888" />
						</el-form-item>
						<el-form-item label="Token">
							<el-input v-model.trim="item.token" :disabled="!isAdmin" show-password placeholder="请输入宝塔 API Token" />
						</el-form-item>
						<el-form-item label="Web ID">
							<el-input v-model.trim="item.web_id" :disabled="!isAdmin" placeholder="请输入宝塔站点 ID" />
						</el-form-item>
						<el-form-item label="Web Name">
							<el-input v-model.trim="item.web_name" :disabled="!isAdmin" placeholder="请输入宝塔站点名称" />
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model.trim="item.remark" :disabled="!isAdmin" placeholder="请输入该宝塔配置的备注信息" />
						</el-form-item>
						<el-form-item label="通知群组">
							<el-input v-model.trim="item.notify_room" :disabled="!isAdmin" placeholder="请输入通知群组 ID，例如：-1001234567890" />
						</el-form-item>
					</el-card>
				</template>
				<el-empty v-if="isLanding && form.config.length === 0" description="暂无宝塔配置" />
				<el-form-item v-if="isLanding && isAdmin">
					<el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		name: 'SystemLanding',
		components: {
			AgreeCountry: () => import('@/views/country/white')
		},
		data() {
			return {
				saving: false,
				key: 'LANDING',
				form: { config: [], desc: '', id: 1, remarks: '' }
			};
		},
		computed: {
			isAdmin() {
				const info = JSON.parse(sessionStorage.getItem('admin-info') || '{}');
				return Number(info.group_id) === 99;
			},
			isLanding() {
				return this.key === 'LANDING';
			},
			isCountry() {
				return this.key === 'COUNTRY';
			}
		},
		created() {
			this.load();
		},
		methods: {
			load() {
				if (this.isCountry) return;
				this.request.get('/system', { params: { key: 'LANDING' } }).then((data) => {
					this.form = Object.assign({ config: [] }, data);
					if (!Array.isArray(this.form.config)) this.form.config = [];
				});
			},
			addConfig() {
				this.form.config.push({ host: '', token: '', web_id: '', web_name: '', remark: '', notify_room: '' });
			},
			removeConfig(index) {
				this.form.config.splice(index, 1);
			},
			save() {
				this.saving = true;
				const data = { config: this.form.config, desc: this.form.desc, id: this.form.id, remarks: this.form.remarks };
				const content = JSON.stringify(data);
				this.request
					.post('/system', { key: this.key, content })
					.then(() => {
						this.$message.success('保存成功');
					})
					.finally(() => {
						this.saving = false;
					});
			}
		}
	};
</script>

<style scoped>
	.system-page {
		padding-top: 18px;
	}
	.system-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;
		padding: 18px 24px;
		border-radius: 10px;
		color: #fff;
		background: linear-gradient(120deg, #47657d, #5d8a83);
		box-shadow: 0 8px 18px rgba(68, 103, 125, 0.15);
	}
	.system-heading p {
		margin: 0 0 6px;
		color: rgba(255, 255, 255, 0.7);
		font-size: 10px;
		font-weight: 700;
		letter-spacing: 1.5px;
	}
	.system-heading h2 {
		margin: 0;
		font-size: 22px;
	}
	.system-heading span {
		display: inline-block;
		margin-top: 6px;
		color: rgba(255, 255, 255, 0.84);
		font-size: 13px;
	}
	.system-card {
		border: 0;
		border-radius: 12px;
		box-shadow: 0 5px 20px rgba(26, 45, 72, 0.08);
	}
	.config-card {
		margin-bottom: 14px;
		border-color: #e9eff1;
		border-radius: 9px;
	}
	.config-card ::v-deep .el-card__header {
		padding: 13px 18px;
		color: #30465a;
		font-weight: 600;
		background: #f8fbfb;
	}
	.config-card ::v-deep .el-card__body {
		padding: 16px 18px 2px;
	}
	.remove-button {
		color: #d56b6b;
	}
	.system-card ::v-deep > .el-card__body {
		padding: 0 24px 22px;
	}
	.system-card ::v-deep .el-tabs__header {
		margin: 0 -24px 22px;
		padding: 0 24px;
		background: #f9fbfb;
	}
	.system-card ::v-deep .el-tabs__item {
		height: 56px;
		line-height: 56px;
		font-size: 15px;
	}
	@media (max-width: 640px) {
		.system-heading {
			padding: 18px;
		}
		.system-heading > .el-button {
			display: none;
		}
		.system-card ::v-deep > .el-card__body {
			padding: 0 14px 16px;
		}
		.system-card ::v-deep .el-tabs__header {
			margin: 0 -14px 18px;
			padding: 0 14px;
		}
	}
</style>
